import React, { useCallback, useReducer } from "react";
import SnackAlert from "../components/SnackAlert";

const actionTypes = {
  show_alert: "show_alert",
  close_alert: "close_alert",
};

const snackAlertReducer = (alert, action) => {
  switch (action.type) {
    case actionTypes.show_alert: {
      return {
        open: true,
        messages: action.messages,
        severity: action.severity,
        showAction: action.showAction,
      };
    }
    case actionTypes.close_alert: {
      return { ...alert, open: false };
    }
    default: {
      throw new Error(`Unhandled type in snackAlertReducer: ${action.type}`);
    }
  }
};

const useSnackAlert = ({ reducer = snackAlertReducer } = {}) => {
  const [alert, dispatch] = useReducer(reducer, {
    open: false,
    messages: [],
    severity: "error",
    showAction: false,
  });

  const showAlert = useCallback((severity, messages, showAction = false) => {
    dispatch({
      type: actionTypes.show_alert,
      severity,
      messages,
      showAction,
    });
  }, []);

  const closeAlert = useCallback(() => {
    dispatch({
      type: actionTypes.close_alert,
    });
  }, []);

  const WrappedSnackAlert = React.forwardRef((props, ref) => (
    <SnackAlert handler={{ alert, closeAlert }} {...props} ref={ref} />
  ));

  return { alert, showAlert, closeAlert, SnackAlert: WrappedSnackAlert };
};

export { useSnackAlert, actionTypes };
